export enum ElementType {
  NOT_SPECIFIED,
  FOLDER,
  PDF_FILE,
}
